import React from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE3, valueTipePembayaran } from "App/constants";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";
import { isNull } from "App/utils/helpers";

export default function FormFilterServiceTutupTagihan({
  formFilter,
  setFormFilter,
  setNewData,
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const kasBank = useSelectOption(
    true,
    "/kas/kas/list",
    TYPE_INSTANCE3,
    "id",
    "nama"
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={4}>
            <InputTextMaster
              name='id'
              label='ID'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='ID'
            />
          </Grid>

          <Grid item sm={4}>
            <InputOptionMaster
              name='tipe_pembayaran_id'
              label='TIPE PEMBAYARAN'
              id='tipe_pembayaran_id'
              withSearch={false}
              data={valueTipePembayaran}
              value={formFilter.tipe_pembayaran_id}
              onChange={handleChange("tipe_pembayaran_id")}
            />
          </Grid>

          <Grid item sm={4}>
            <InputOptionMaster
              name='kas_id'
              label='KAS'
              id='kas_id'
              withSearch={true}
              data={kasBank}
              value={formFilter.kas_id}
              labelValue={formFilter.kas_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    kas_id: null,
                    kas_name: "Pilih Kas",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    kas_id: e.value,
                    kas_name: e.label,
                  });
                }
              }}
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
